export default class LoadingAnimation {
  constructor(elem, opts) {
    // this.elm = elem
    this.eventBinds()
  }

  eventBinds() {
    const _this = this
    window.addEventListener('load', ()=> {
      _this.topLoadingAnim()
    })
  }

  topLoadingAnim(){
    const loadingWrapElm = document.getElementById('loadingWrap')
    const loadingContainerElm = document.getElementById('loadingContainer')
    const loadingProgressElm = document.getElementById('loadingProgress')
    const loadingPercentageElm = document.getElementById('loadingPercentage')
    const loadingFinishElm = document.getElementById('loadingFinish')
    const loadingProgressTextAry = loadingProgressElm.innerHTML.split('')

    const videoElmPC = document.getElementById('kvVideoPC')
    const videoElmSP = document.getElementById('kvVideoSP')
    let currentPercentage = 0
    let intervalTime = 200
    let loadedFlg = false

    loadingProgressElm.innerHTML = "#"
    loadingPercentageElm.innerHTML = "0%"

    function updateLoadingAnim(){
      currentPercentage+=1
      if(intervalTime >= 5 && loadedFlg){
        intervalTime = intervalTime * 0.82
      }
  
      // パーセンテージ数値更新
      loadingPercentageElm.innerHTML = String(currentPercentage) + "%"
  
      // プログレスアイコン更新
      const progressTextCount = Math.round(currentPercentage /100 * loadingProgressTextAry.length)
      let progressText = "#"
      for(let i=0; i<progressTextCount - 1; i++){
        progressText+="#"
      }
      loadingProgressElm.innerHTML = progressText
    
      if(currentPercentage >= 100){
        loadingFinishElm.classList.add('is-active')
        loadingWrapElm.classList.add('is-deactivate')

        if(window.innerWidth <= 768){
          videoElmSP.play()
        }else{
          videoElmPC.play()
        }
      }else{
        setTimeout(updateLoadingAnim, intervalTime)
      }
    }

    loadingContainerElm.classList.add('is-active')

    setTimeout(() => {
      updateLoadingAnim()
    }, 500)

    if(window.innerWidth <= 768){
      videoElmSP.addEventListener('loadeddata', ()=>{
        loadedFlg = true
      })
    }else{
      videoElmPC.addEventListener('loadeddata', ()=>{
        loadedFlg = true
      })
    }
    setTimeout(() => {
      if(!loadedFlg){
        loadedFlg = true
      }
    }, 1000)
  }
}